import { MessagePlugin } from 'tdesign-vue-next';

/**
 * @description  文件类型校验
 * @param {
 *  file: file // 校验的文件对象
 *  allowTypes: [] // 合法的文件类型
 * }
 * @return {boolean}
 * */
export const fileTypeCheck = (file, allowTypes) => {
  const fileName = file.name;
  const postfix = fileName.substring(fileName.lastIndexOf('.')).toUpperCase();
  if (allowTypes.indexOf(postfix) < 0) {
    MessagePlugin.error('文件格式不正确');
    return false;
  }
  return true;
};

/**
 * @description  文件大小校验
 * @param {
 *  file: file // 校验的文件对象
 *  allowSize: number // 允许的文件大小
 *  units: string 'GB'|'MB'|'KB' // 描述文件大小的单位
 * }
 * @return {boolean}
 * */
export const fileizeCheck = (file, allowSize, units) => {
  const maps = {
    GB: 30,
    MB: 20,
    KB: 10
  };
  if (file.size > allowSize * Math.pow(2, maps[units])) {
    MessagePlugin.error(`文件大小不能大于${allowSize}${units}`);
    return false;
  }
  return true;
};

/**
 * @description  校验图片宽高
 * @param {
 *  file: file // 图片文件
 *  width: number
 *  height: number
 * }
 * @return {boolean}
 * */
export const validImage = (file, width, height, flag = true) => {
  if (!flag) {
    return new Promise((solve) => {
      solve(true);
    });
  }
  return new Promise((resolve) => {
    const URL = window.URL || window.webkitURL;
    const img = new Image();
    img.src = URL.createObjectURL(file.raw);
    img.addEventListener('load', function () {
      const valid = img.width === width && img.height === height;
      if (!valid)
        MessagePlugin.error(`请上传尺寸为 ${width} * ${height} 的图片！`);
      resolve(valid);
    });
  });
};

export const openATagToDownloadUrl = (url, fileName = '') => {
  const a = document.createElement('a');
  a.download = fileName;
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
